import React from 'react'
import i18n from 'i18n'
import { AgentLoginAction, WrapperHeader } from './styles'
import { Button } from 'components/atoms'

export const AgentLoginHeader = ({ onSubmit }: { onSubmit: () => void }) => {
  return (
    <WrapperHeader>
      <AgentLoginAction>
        <div className="processing-title" color="grey">
          {i18n.t('components.AgentLoginHeader.agent_login_processing')}
        </div>
        <Button type="button" size="short" color="grey" onClick={onSubmit}>
          {i18n.t('components.AgentLoginHeader.finish_agent_login')}
        </Button>
      </AgentLoginAction>
    </WrapperHeader>
  )
}
